import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { PainPoints } from "@/components/landing/PainPoints";
import { Benefits } from "@/components/landing/Benefits";
import { Compare } from "@/components/landing/Compare";
import { ForWho } from "@/components/landing/ForWho";
import { Reviews } from "@/components/landing/Reviews";
import { Partner } from "@/components/landing/Partner";
import { Faq } from "@/components/landing/Faq";
import { FinalCta, Footer } from "@/components/landing/FinalCta";
import { StickyBar } from "@/components/landing/StickyBar";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PainPoints />
        <Benefits />
        <Compare />
        <ForWho />
        <Reviews />
        <Partner />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
